import { render, staticRenderFns } from "./DrawerGroupForm.vue?vue&type=template&id=fa6d66c8"
import script from "./DrawerGroupForm.vue?vue&type=script&lang=js"
export * from "./DrawerGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports